"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isEuropeRegion = exports.EURO_COUNTRY_SET = exports.EURO_COUNTRY_LIST = void 0;
exports.EURO_COUNTRY_LIST = [
    'at',
    'be',
    'bg',
    'hr',
    'ch',
    'cy',
    'cz',
    'de',
    'dk',
    'ee',
    'el',
    'fi',
    'fr',
    'gb',
    'gr',
    'hu',
    'ie',
    'it',
    'lv',
    'lt',
    'lu',
    'mt',
    'nl',
    'pl',
    'pt',
    'ro',
    'sk',
    'si',
    'es',
    'se',
    'no',
    'is',
    'li',
];
exports.EURO_COUNTRY_SET = new Set(exports.EURO_COUNTRY_LIST);
const isEuropeRegion = (region) => exports.EURO_COUNTRY_SET.has(region);
exports.isEuropeRegion = isEuropeRegion;
